import { PlusOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { EmptyTab } from '../shared/components/styled/EmptyTab';
import { ANTD_GRAY } from '../shared/constants';
import AddRelatedNodeModal from '../glossaryTerm/profile/AddRelatedTermsModal';
import { RelatedTermTypes } from '../shared/components/styled/search/types';
import RelatedNode from '../glossaryTerm/profile/RelatedTerm';
import { EntityType } from '../../../types.generated';

export enum RelatedNodeTypes {
    typeOfRelations = 'Type Of',
    isTypeOf = 'Has Type',
}

export type Props = {
    loading?: boolean;
    glossaryRelatedNodeType: string;
    glossaryRelatedNodeResult: Array<any>;
    trackTermLoading: (urn: string, trackLoading: boolean) => void;
};

const ListContainer = styled.div`
    width: 100%;
    background-color: ${ANTD_GRAY[1]};
`;

const TitleContainer = styled.div`
    align-items: center;
    border-bottom: solid 1px ${ANTD_GRAY[4]};
    display: flex;
    justify-content: space-between;
    padding: 15px 20px;
`;

export default function GlossaryRelatedNodesResult({
    loading,
    trackTermLoading,
    glossaryRelatedNodeType,
    glossaryRelatedNodeResult,
}: Props) {
    const [isShowingAddModal, setIsShowingAddModal] = useState(false);
    const glossaryRelatedNodeUrns: Array<string> = [];

    glossaryRelatedNodeResult.forEach((item: any) => {
        glossaryRelatedNodeUrns.push(item?.entity?.urn);
    });

    const canEditRelatedTerms = glossaryRelatedNodeType === RelatedNodeTypes.typeOfRelations;
    return (
        <>
            <ListContainer>
                <TitleContainer>
                    <Typography.Title style={{ margin: '0' }} level={3}>
                        {glossaryRelatedNodeType}
                    </Typography.Title>
                    {canEditRelatedTerms && (
                        <Button type="text" onClick={() => setIsShowingAddModal(true)} aria-label="Add Nodes">
                            <PlusOutlined aria-hidden="true" /> Add Term Groups
                        </Button>
                    )}
                </TitleContainer>
                {glossaryRelatedNodeUrns.map((urn) => (
                    <RelatedNode
                        key={urn}
                        urn={urn}
                        isLoading={loading}
                        isEditable={canEditRelatedTerms}
                        entityType={EntityType.GlossaryNode}
                        relatedEntityType={glossaryRelatedNodeType}
                        relationshipType={RelatedTermTypes.typeOfRelations}
                        onLoadingChange={(isLoading) => trackTermLoading?.(urn, isLoading)}
                    />
                ))}
                {glossaryRelatedNodeUrns.length === 0 && (
                    <EmptyTab tab={`node ${glossaryRelatedNodeType.toLocaleLowerCase()}`} />
                )}
            </ListContainer>
            {isShowingAddModal && (
                <AddRelatedNodeModal
                    isTypeTermGroup
                    entityType={EntityType.GlossaryNode}
                    onClose={() => setIsShowingAddModal(false)}
                />
            )}
        </>
    );
}
